import isEmpty from 'lodash/fp/isEmpty';
import intersection from 'lodash/fp/intersection';
import { PermissionAction, ResourcePolicy } from '../models/permission';

export const hasPermission = (
  permissionMapping: Map<ResourcePolicy, PermissionAction[]>,
  resource?: ResourcePolicy,
  actions?: PermissionAction[],
) => {
  if (resource === undefined || actions === undefined) {
    return false;
  }
  const permissionActions = permissionMapping.get(resource);
  return !isEmpty(intersection(permissionActions, actions));
};
